module.exports = __webpack_public_path__ + "static/Sujan Kandeepan.b2ff3e1f.jpg";


//////////////////
// WEBPACK FOOTER
// ./src/assets/images/mentors/Sujan Kandeepan.jpg
// module id = 1238
// module chunks = 6166952557895